unit uSubForm1;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Grids, WEBLib.DBCtrls,
  WEBLib.Controls, WEBLib.ExtCtrls, WEBLib.CDS, Data.DB, WEBLib.DB,
  Vcl.Graphics, WEBLib.Buttons, Vcl.Imaging.pngimage, Vcl.Imaging.jpeg;

type
  TSubForm1 = class(TForm)
    WebLabel7: TLabel;
    WebLabel26: TLabel;
    WebComboBox1: TComboBox;
    WebComboBox2: TComboBox;
    WebComboBox3: TComboBox;
    WebComboBox4: TComboBox;
    WebComboBox5: TComboBox;
    WebComboBox6: TComboBox;
    WebComboBox7: TComboBox;
    WebComboBox8: TComboBox;
    WebComboBox9: TComboBox;
    WebLabel13: TLabel;
    WebLabel14: TLabel;
    WebLabel16: TLabel;
    WebLabel21: TLabel;
    WebLabel22: TLabel;
    WebLabel23: TLabel;
    WebLabel24: TLabel;
    WebLabel25: TLabel;
    WebLabel28: TLabel;
    Dom: TImageControl;
    WebCheckBox1: TCheckBox;
    WebCheckBox2: TCheckBox;
    WebCheckBox3: TCheckBox;
    WebCheckBox4: TCheckBox;
    WebCheckBox5: TCheckBox;
    WebCheckBox6: TCheckBox;
    WebCheckBox7: TCheckBox;
    WebCheckBox8: TCheckBox;
    WebCheckBox9: TCheckBox;
    WebEdit6: TEdit;
    WebEdit7: TEdit;
    WebEdit12: TEdit;
    WebEdit13: TEdit;
    WebEdit14: TEdit;
    WebEdit15: TEdit;
    WebEdit18: TEdit;
    WebEdit19: TEdit;
    WebEdit20: TEdit;
    Opis: TImageControl;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    procedure WebComboBox1Click(Sender: TObject);
    procedure WebComboBox2Click(Sender: TObject);
    procedure WebComboBox3Click(Sender: TObject);
    procedure WebComboBox4Click(Sender: TObject);
    procedure WebComboBox5Click(Sender: TObject);
    procedure WebComboBox6Click(Sender: TObject);
    procedure WebComboBox7Click(Sender: TObject);
    procedure WebComboBox8Click(Sender: TObject);
    procedure WebComboBox9Click(Sender: TObject);

  protected procedure LoadDFMValues; override; end;

var
  SubForm1: TSubForm1;

implementation

{$R *.dfm}

uses  uFrmMain;

procedure TSubForm1.WebComboBox1Click(Sender: TObject);
var   ILO, ILO_P        : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox1.ItemIndex;
ILO_P:=StrtoFloat(WebEdit6.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
MIE:=StrtoFloat(FrmMain.txtSampleText.Text);
PO:=WebComboBox1.ItemIndex;
case PO of
0: ILO:=2.52;
1: ILO:=2.18;
2: ILO:=1.89;
3: ILO:=1.38;
4: ILO:=1.05;
5: ILO:=0.9;
6: ILO:=0.74;
7: ILO:=0.17;
8: ILO:=0.18;
9: ILO:=1.26;
end;
MIE:=MIE+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox1.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox1.Checked=true then MIE:=MIE-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.txtSampleText.Text:=FloattoStr(MIE);
WebEdit6.Text:=FloattoStr(ILO);
WebCheckBox1.Checked:=true;
WebComboBox1.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox2.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if WebCheckBox6.Checked=true then TAK:=Tak+1;
if WebCheckBox7.Checked=true then TAK:=Tak+1;
if WebCheckBox8.Checked=true then TAK:=Tak+1;
if WebCheckBox9.Checked=true then TAK:=Tak+1;
if TAK=9 then  FrmMain.WebEdit6.Text:='1';
end;

procedure TSubForm1.WebComboBox2Click(Sender: TObject);
var   ILO, ILO_P   : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox2.ItemIndex;
ILO_P:=StrtoFloat(WebEdit7.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
MIE:=StrtoFloat(FrmMain.txtSampleText.Text);
PO:=WebComboBox2.ItemIndex;
case PO of
0: ILO:=0.07;
1: ILO:=-0.71;
2: ILO:=-1.06;
3: ILO:=-0.81;
4: ILO:=-1.22;
5: ILO:=-1.42;
6: ILO:=-2.04;
7: ILO:=-0.1;
end;
MIE:=MIE+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox2.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox2.Checked=true then MIE:=MIE-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.txtSampleText.Text:=FloattoStr(MIE);
WebEdit7.Text:=FloattoStr(ILO);
WebCheckBox2.Checked:=true;
WebComboBox2.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox2.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if WebCheckBox6.Checked=true then TAK:=Tak+1;
if WebCheckBox7.Checked=true then TAK:=Tak+1;
if WebCheckBox8.Checked=true then TAK:=Tak+1;
if WebCheckBox9.Checked=true then TAK:=Tak+1;
if TAK=9 then  FrmMain.WebEdit6.Text:='1';
end;

procedure TSubForm1.WebComboBox3Click(Sender: TObject);
var   ILO, ILO_P   : Real;
       PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox3.ItemIndex;
ILO_P:=StrtoFloat(WebEdit12.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
MIE:=StrtoFloat(FrmMain.txtSampleText.Text);
PO:=WebComboBox3.ItemIndex;
case PO of
0: ILO:=5.68;
1: ILO:=4.41;
2: ILO:=2.52;
3: ILO:=1.57;
4: ILO:=0.94;
5: ILO:=0.3;
6: ILO:=-0.33;
7: ILO:=-0.96;
8: ILO:=-1.32;
end;
MIE:=MIE+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox3.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox3.Checked=true then MIE:=MIE-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.txtSampleText.Text:=FloattoStr(MIE);
WebEdit12.Text:=FloattoStr(ILO);
WebCheckBox3.Checked:=true;
WebComboBox3.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox2.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if WebCheckBox6.Checked=true then TAK:=Tak+1;
if WebCheckBox7.Checked=true then TAK:=Tak+1;
if WebCheckBox8.Checked=true then TAK:=Tak+1;
if WebCheckBox9.Checked=true then TAK:=Tak+1;
if TAK=9 then  FrmMain.WebEdit6.Text:='1';
end;

procedure TSubForm1.WebComboBox4Click(Sender: TObject);
var   ILO, ILO_P   : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox4.ItemIndex;
ILO_P:=StrtoFloat(WebEdit13.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
MIE:=StrtoFloat(FrmMain.txtSampleText.Text);
PO:=WebComboBox4.ItemIndex;
case PO of
0: ILO:=1.84;
1: ILO:=0;
2: ILO:=-0.57;
3: ILO:=-0.85;
4: ILO:=-1.01;
5: ILO:=-1.11;
6: ILO:=-1.18;
end;
MIE:=MIE+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox4.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox4.Checked=true then MIE:=MIE-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.txtSampleText.Text:=FloattoStr(MIE);
WebEdit13.Text:=FloattoStr(ILO);
WebCheckBox4.Checked:=true;
WebComboBox4.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox2.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if WebCheckBox6.Checked=true then TAK:=Tak+1;
if WebCheckBox7.Checked=true then TAK:=Tak+1;
if WebCheckBox8.Checked=true then TAK:=Tak+1;
if WebCheckBox9.Checked=true then TAK:=Tak+1;
if TAK=9 then  FrmMain.WebEdit6.Text:='1';
end;

procedure TSubForm1.WebComboBox5Click(Sender: TObject);
var   ILO, ILO_P   : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox5.ItemIndex;
ILO_P:=StrtoFloat(WebEdit14.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
MIE:=StrtoFloat(FrmMain.txtSampleText.Text);
PO:=WebComboBox5.ItemIndex;
case PO of
0: ILO:=0.04;
1: ILO:=0;
2: ILO:=-0.04;
3: ILO:=-0.08;
4: ILO:=0;
end;
MIE:=MIE+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox5.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox5.Checked=true then MIE:=MIE-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.txtSampleText.Text:=FloattoStr(MIE);
WebEdit14.Text:=FloattoStr(ILO);
WebCheckBox5.Checked:=true;
WebComboBox5.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox2.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if WebCheckBox6.Checked=true then TAK:=Tak+1;
if WebCheckBox7.Checked=true then TAK:=Tak+1;
if WebCheckBox8.Checked=true then TAK:=Tak+1;
if WebCheckBox9.Checked=true then TAK:=Tak+1;
if TAK=9 then  FrmMain.WebEdit6.Text:='1';
end;

procedure TSubForm1.WebComboBox6Click(Sender: TObject);
var   ILO, ILO_P   : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox6.ItemIndex;
ILO_P:=StrtoFloat(WebEdit15.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
MIE:=StrtoFloat(FrmMain.txtSampleText.Text);
PO:=WebComboBox6.ItemIndex;
case PO of
0: ILO:=0.53;
1: ILO:=0.46;
2: ILO:=0.4;
3: ILO:=0.29;
4: ILO:=0.15;
5: ILO:=0.19;
6: ILO:=0.15;
7: ILO:=0.04;
8: ILO:=0.03;
9: ILO:=0.26;
end;
MIE:=MIE+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox6.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox6.Checked=true then MIE:=MIE-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.txtSampleText.Text:=FloattoStr(MIE);
WebEdit15.Text:=FloattoStr(ILO);
WebCheckBox6.Checked:=true;
WebComboBox6.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox2.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if WebCheckBox6.Checked=true then TAK:=Tak+1;
if WebCheckBox7.Checked=true then TAK:=Tak+1;
if WebCheckBox8.Checked=true then TAK:=Tak+1;
if WebCheckBox9.Checked=true then TAK:=Tak+1;
if TAK=9 then  FrmMain.WebEdit6.Text:='1';
end;

procedure TSubForm1.WebComboBox7Click(Sender: TObject);
var   ILO, ILO_P   : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox7.ItemIndex;
ILO_P:=StrtoFloat(WebEdit18.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
MIE:=StrtoFloat(FrmMain.txtSampleText.Text);
PO:=WebComboBox7.ItemIndex;
case PO of
0: ILO:=0.16;
1: ILO:=0.13;
2: ILO:=0.09;
3: ILO:=0.08;
4: ILO:=0.16;
5: ILO:=0.11;
end;
MIE:=MIE+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox7.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox7.Checked=true then MIE:=MIE-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.txtSampleText.Text:=FloattoStr(MIE);
WebEdit18.Text:=FloattoStr(ILO);
WebCheckBox7.Checked:=true;
WebComboBox7.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox2.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if WebCheckBox6.Checked=true then TAK:=Tak+1;
if WebCheckBox7.Checked=true then TAK:=Tak+1;
if WebCheckBox8.Checked=true then TAK:=Tak+1;
if WebCheckBox9.Checked=true then TAK:=Tak+1;
if TAK=9 then  FrmMain.WebEdit6.Text:='1';
end;

procedure TSubForm1.WebComboBox8Click(Sender: TObject);
var   ILO, ILO_P   : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox8.ItemIndex;
ILO_P:=StrtoFloat(WebEdit19.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
MIE:=StrtoFloat(FrmMain.txtSampleText.Text);
PO:=WebComboBox8.ItemIndex;
case PO of
0: ILO:=0.32;
1: ILO:=0.11;
2: ILO:=0.08;
end;
MIE:=MIE+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox8.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox8.Checked=true then MIE:=MIE-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.txtSampleText.Text:=FloattoStr(MIE);
WebEdit19.Text:=FloattoStr(ILO);
WebCheckBox8.Checked:=true;
WebComboBox8.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox2.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if WebCheckBox6.Checked=true then TAK:=Tak+1;
if WebCheckBox7.Checked=true then TAK:=Tak+1;
if WebCheckBox8.Checked=true then TAK:=Tak+1;
if WebCheckBox9.Checked=true then TAK:=Tak+1;
if TAK=9 then  FrmMain.WebEdit6.Text:='1';
end;

procedure TSubForm1.WebComboBox9Click(Sender: TObject);
var   ILO, ILO_P   : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox9.ItemIndex;
ILO_P:=StrtoFloat(WebEdit20.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
MIE:=StrtoFloat(FrmMain.txtSampleText.Text);
PO:=WebComboBox9.ItemIndex;
case PO of
0: ILO:=0.32;
1: ILO:=0.11;
2: ILO:=0.08;
end;
MIE:=MIE+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox9.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox9.Checked=true then MIE:=MIE-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.txtSampleText.Text:=FloattoStr(MIE);
WebEdit20.Text:=FloattoStr(ILO);
WebCheckBox9.Checked:=true;
WebComboBox9.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox2.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if WebCheckBox6.Checked=true then TAK:=Tak+1;
if WebCheckBox7.Checked=true then TAK:=Tak+1;
if WebCheckBox8.Checked=true then TAK:=Tak+1;
if WebCheckBox9.Checked=true then TAK:=Tak+1;
if TAK=9 then  FrmMain.WebEdit6.Text:='1';
end;
procedure TSubForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel7 := TLabel.Create(Self);
  WebLabel26 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebLabel21 := TLabel.Create(Self);
  WebLabel22 := TLabel.Create(Self);
  WebLabel23 := TLabel.Create(Self);
  WebLabel24 := TLabel.Create(Self);
  WebLabel25 := TLabel.Create(Self);
  WebLabel28 := TLabel.Create(Self);
  Dom := TImageControl.Create(Self);
  Opis := TImageControl.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebCheckBox9 := TCheckBox.Create(Self);
  WebCheckBox8 := TCheckBox.Create(Self);
  WebCheckBox7 := TCheckBox.Create(Self);
  WebCheckBox6 := TCheckBox.Create(Self);
  WebCheckBox5 := TCheckBox.Create(Self);
  WebCheckBox4 := TCheckBox.Create(Self);
  WebCheckBox3 := TCheckBox.Create(Self);
  WebCheckBox2 := TCheckBox.Create(Self);
  WebCheckBox1 := TCheckBox.Create(Self);
  WebComboBox1 := TComboBox.Create(Self);
  WebComboBox2 := TComboBox.Create(Self);
  WebComboBox3 := TComboBox.Create(Self);
  WebComboBox4 := TComboBox.Create(Self);
  WebComboBox5 := TComboBox.Create(Self);
  WebComboBox6 := TComboBox.Create(Self);
  WebComboBox7 := TComboBox.Create(Self);
  WebComboBox8 := TComboBox.Create(Self);
  WebComboBox9 := TComboBox.Create(Self);
  WebEdit6 := TEdit.Create(Self);
  WebEdit7 := TEdit.Create(Self);
  WebEdit12 := TEdit.Create(Self);
  WebEdit13 := TEdit.Create(Self);
  WebEdit14 := TEdit.Create(Self);
  WebEdit15 := TEdit.Create(Self);
  WebEdit18 := TEdit.Create(Self);
  WebEdit19 := TEdit.Create(Self);
  WebEdit20 := TEdit.Create(Self);

  WebLabel7.BeforeLoadDFMValues;
  WebLabel26.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebLabel22.BeforeLoadDFMValues;
  WebLabel23.BeforeLoadDFMValues;
  WebLabel24.BeforeLoadDFMValues;
  WebLabel25.BeforeLoadDFMValues;
  WebLabel28.BeforeLoadDFMValues;
  Dom.BeforeLoadDFMValues;
  Opis.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebCheckBox9.BeforeLoadDFMValues;
  WebCheckBox8.BeforeLoadDFMValues;
  WebCheckBox7.BeforeLoadDFMValues;
  WebCheckBox6.BeforeLoadDFMValues;
  WebCheckBox5.BeforeLoadDFMValues;
  WebCheckBox4.BeforeLoadDFMValues;
  WebCheckBox3.BeforeLoadDFMValues;
  WebCheckBox2.BeforeLoadDFMValues;
  WebCheckBox1.BeforeLoadDFMValues;
  WebComboBox1.BeforeLoadDFMValues;
  WebComboBox2.BeforeLoadDFMValues;
  WebComboBox3.BeforeLoadDFMValues;
  WebComboBox4.BeforeLoadDFMValues;
  WebComboBox5.BeforeLoadDFMValues;
  WebComboBox6.BeforeLoadDFMValues;
  WebComboBox7.BeforeLoadDFMValues;
  WebComboBox8.BeforeLoadDFMValues;
  WebComboBox9.BeforeLoadDFMValues;
  WebEdit6.BeforeLoadDFMValues;
  WebEdit7.BeforeLoadDFMValues;
  WebEdit12.BeforeLoadDFMValues;
  WebEdit13.BeforeLoadDFMValues;
  WebEdit14.BeforeLoadDFMValues;
  WebEdit15.BeforeLoadDFMValues;
  WebEdit18.BeforeLoadDFMValues;
  WebEdit19.BeforeLoadDFMValues;
  WebEdit20.BeforeLoadDFMValues;
  try
    Name := 'SubForm1';
    Width := 708;
    Height := 463;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    WebLabel7.SetParentComponent(Self);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 8;
    WebLabel7.Top := 438;
    WebLabel7.Width := 211;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Kalkulator fotowoltaiczny - Pro-Sun (c) 2022';
    WebLabel7.Color := clYellow;
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.Transparent := False;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel26.SetParentComponent(Self);
    WebLabel26.Name := 'WebLabel26';
    WebLabel26.Left := 8;
    WebLabel26.Top := 58;
    WebLabel26.Width := 124;
    WebLabel26.Height := 18;
    WebLabel26.Caption := 'Mieszkanie/dom';
    WebLabel26.Font.Charset := DEFAULT_CHARSET;
    WebLabel26.Font.Color := clMenuHighlight;
    WebLabel26.Font.Height := -15;
    WebLabel26.Font.Name := 'Tahoma';
    WebLabel26.Font.Style := [fsBold];
    WebLabel26.HeightPercent := 100.000000000000000000;
    WebLabel26.ParentFont := False;
    WebLabel26.WidthPercent := 100.000000000000000000;
    WebLabel13.SetParentComponent(Self);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 11;
    WebLabel13.Top := 83;
    WebLabel13.Width := 177;
    WebLabel13.Height := 13;
    WebLabel13.Caption := 'Jak ogrzewasz dom/mieszkanie zim'#261'?';
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebLabel14.SetParentComponent(Self);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 11;
    WebLabel14.Top := 106;
    WebLabel14.Width := 259;
    WebLabel14.Height := 13;
    WebLabel14.Caption := 'W jakiej technologii zosta'#322' wykonany dom/mieszkanie?';
    WebLabel14.HeightPercent := 100.000000000000000000;
    WebLabel14.WidthPercent := 100.000000000000000000;
    WebLabel16.SetParentComponent(Self);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 11;
    WebLabel16.Top := 129;
    WebLabel16.Width := 146;
    WebLabel16.Height := 13;
    WebLabel16.Caption := 'Jak du'#380'e jest mieszkanie/dom?';
    WebLabel16.HeightPercent := 100.000000000000000000;
    WebLabel16.WidthPercent := 100.000000000000000000;
    WebLabel21.SetParentComponent(Self);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 11;
    WebLabel21.Top := 152;
    WebLabel21.Width := 218;
    WebLabel21.Height := 13;
    WebLabel21.Caption := 'Ile os'#243'b mieszka w gospodarstwie domowym?';
    WebLabel21.HeightPercent := 100.000000000000000000;
    WebLabel21.WidthPercent := 100.000000000000000000;
    WebLabel22.SetParentComponent(Self);
    WebLabel22.Name := 'WebLabel22';
    WebLabel22.Left := 11;
    WebLabel22.Top := 175;
    WebLabel22.Width := 220;
    WebLabel22.Height := 13;
    WebLabel22.Caption := 'Do ilu stopni ogrzewasz sw'#243'j dom/mieszkanie?';
    WebLabel22.HeightPercent := 100.000000000000000000;
    WebLabel22.WidthPercent := 100.000000000000000000;
    WebLabel23.SetParentComponent(Self);
    WebLabel23.Name := 'WebLabel23';
    WebLabel23.Left := 11;
    WebLabel23.Top := 198;
    WebLabel23.Width := 165;
    WebLabel23.Height := 13;
    WebLabel23.Caption := 'Jak przygotowujesz gor'#261'c'#261' wod'#281'?';
    WebLabel23.HeightPercent := 100.000000000000000000;
    WebLabel23.WidthPercent := 100.000000000000000000;
    WebLabel24.SetParentComponent(Self);
    WebLabel24.Name := 'WebLabel24';
    WebLabel24.Left := 11;
    WebLabel24.Top := 221;
    WebLabel24.Width := 274;
    WebLabel24.Height := 13;
    WebLabel24.Caption := 'Jak'#261' klas'#281' efektywno'#347'ci posiada o'#347'wietlenie i du'#380'e  AGD?';
    WebLabel24.HeightPercent := 100.000000000000000000;
    WebLabel24.WidthPercent := 100.000000000000000000;
    WebLabel25.SetParentComponent(Self);
    WebLabel25.Name := 'WebLabel25';
    WebLabel25.Left := 11;
    WebLabel25.Top := 244;
    WebLabel25.Width := 162;
    WebLabel25.Height := 13;
    WebLabel25.Caption := 'Jakie masz urz'#261'dzenia ch'#322'odz'#261'ce?';
    WebLabel25.HeightPercent := 100.000000000000000000;
    WebLabel25.WidthPercent := 100.000000000000000000;
    WebLabel28.SetParentComponent(Self);
    WebLabel28.Name := 'WebLabel28';
    WebLabel28.Left := 11;
    WebLabel28.Top := 267;
    WebLabel28.Width := 94;
    WebLabel28.Height := 13;
    WebLabel28.Caption := 'Jak suszysz pranie?';
    WebLabel28.HeightPercent := 100.000000000000000000;
    WebLabel28.WidthPercent := 100.000000000000000000;
    Dom.SetParentComponent(Self);
    Dom.Name := 'Dom';
    Dom.Left := 400;
    Dom.Top := 290;
    Dom.Width := 288;
    Dom.Height := 163;
    Dom.HeightPercent := 100.000000000000000000;
    Dom.WidthPercent := 100.000000000000000000;
    Dom.ChildOrder := 20;
    Dom.Picture.LoadFromFile('uSubForm1.Dom.Picture.jpg');
    Opis.SetParentComponent(Self);
    Opis.Name := 'Opis';
    Opis.Left := 103;
    Opis.Top := 349;
    Opis.Width := 137;
    Opis.Height := 57;
    Opis.HeightPercent := 100.000000000000000000;
    Opis.WidthPercent := 100.000000000000000000;
    Opis.ChildOrder := 3;
    Opis.Picture.LoadFromFile('uSubForm1.Opis.Picture.png');
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 2;
    WebLabel1.Top := 330;
    WebLabel1.Width := 188;
    WebLabel1.Height := 13;
    WebLabel1.Caption := 'Prosz'#281' odpowiedzie'#263' na ka'#380'de pytanie.';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clBlue;
    WebLabel1.Font.Height := -11;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 2;
    WebLabel2.Top := 411;
    WebLabel2.Width := 246;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'Zielone pod'#347'wietlenie oznacza udzielon'#261' odpowied'#378;
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clBlue;
    WebLabel2.Font.Height := -11;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [];
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebCheckBox9.SetParentComponent(Self);
    WebCheckBox9.Name := 'WebCheckBox9';
    WebCheckBox9.Left := 300;
    WebCheckBox9.Top := 264;
    WebCheckBox9.Width := 113;
    WebCheckBox9.Height := 22;
    WebCheckBox9.ChildOrder := 21;
    WebCheckBox9.Color := clNone;
    WebCheckBox9.HeightPercent := 100.000000000000000000;
    WebCheckBox9.State := cbUnchecked;
    WebCheckBox9.Visible := False;
    WebCheckBox9.WidthPercent := 100.000000000000000000;
    WebCheckBox8.SetParentComponent(Self);
    WebCheckBox8.Name := 'WebCheckBox8';
    WebCheckBox8.Left := 300;
    WebCheckBox8.Top := 241;
    WebCheckBox8.Width := 113;
    WebCheckBox8.Height := 22;
    WebCheckBox8.ChildOrder := 21;
    WebCheckBox8.Color := clNone;
    WebCheckBox8.HeightPercent := 100.000000000000000000;
    WebCheckBox8.State := cbUnchecked;
    WebCheckBox8.Visible := False;
    WebCheckBox8.WidthPercent := 100.000000000000000000;
    WebCheckBox7.SetParentComponent(Self);
    WebCheckBox7.Name := 'WebCheckBox7';
    WebCheckBox7.Left := 300;
    WebCheckBox7.Top := 218;
    WebCheckBox7.Width := 113;
    WebCheckBox7.Height := 22;
    WebCheckBox7.ChildOrder := 21;
    WebCheckBox7.Color := clNone;
    WebCheckBox7.HeightPercent := 100.000000000000000000;
    WebCheckBox7.State := cbUnchecked;
    WebCheckBox7.Visible := False;
    WebCheckBox7.WidthPercent := 100.000000000000000000;
    WebCheckBox6.SetParentComponent(Self);
    WebCheckBox6.Name := 'WebCheckBox6';
    WebCheckBox6.Left := 300;
    WebCheckBox6.Top := 195;
    WebCheckBox6.Width := 113;
    WebCheckBox6.Height := 22;
    WebCheckBox6.ChildOrder := 21;
    WebCheckBox6.Color := clNone;
    WebCheckBox6.HeightPercent := 100.000000000000000000;
    WebCheckBox6.State := cbUnchecked;
    WebCheckBox6.Visible := False;
    WebCheckBox6.WidthPercent := 100.000000000000000000;
    WebCheckBox5.SetParentComponent(Self);
    WebCheckBox5.Name := 'WebCheckBox5';
    WebCheckBox5.Left := 300;
    WebCheckBox5.Top := 172;
    WebCheckBox5.Width := 113;
    WebCheckBox5.Height := 22;
    WebCheckBox5.ChildOrder := 21;
    WebCheckBox5.Color := clNone;
    WebCheckBox5.HeightPercent := 100.000000000000000000;
    WebCheckBox5.State := cbUnchecked;
    WebCheckBox5.Visible := False;
    WebCheckBox5.WidthPercent := 100.000000000000000000;
    WebCheckBox4.SetParentComponent(Self);
    WebCheckBox4.Name := 'WebCheckBox4';
    WebCheckBox4.Left := 300;
    WebCheckBox4.Top := 148;
    WebCheckBox4.Width := 113;
    WebCheckBox4.Height := 22;
    WebCheckBox4.ChildOrder := 21;
    WebCheckBox4.Color := clNone;
    WebCheckBox4.HeightPercent := 100.000000000000000000;
    WebCheckBox4.State := cbUnchecked;
    WebCheckBox4.Visible := False;
    WebCheckBox4.WidthPercent := 100.000000000000000000;
    WebCheckBox3.SetParentComponent(Self);
    WebCheckBox3.Name := 'WebCheckBox3';
    WebCheckBox3.Left := 300;
    WebCheckBox3.Top := 123;
    WebCheckBox3.Width := 113;
    WebCheckBox3.Height := 22;
    WebCheckBox3.ChildOrder := 21;
    WebCheckBox3.Color := clNone;
    WebCheckBox3.HeightPercent := 100.000000000000000000;
    WebCheckBox3.State := cbUnchecked;
    WebCheckBox3.Visible := False;
    WebCheckBox3.WidthPercent := 100.000000000000000000;
    WebCheckBox2.SetParentComponent(Self);
    WebCheckBox2.Name := 'WebCheckBox2';
    WebCheckBox2.Left := 300;
    WebCheckBox2.Top := 101;
    WebCheckBox2.Width := 113;
    WebCheckBox2.Height := 22;
    WebCheckBox2.ChildOrder := 21;
    WebCheckBox2.Color := clNone;
    WebCheckBox2.HeightPercent := 100.000000000000000000;
    WebCheckBox2.State := cbUnchecked;
    WebCheckBox2.Visible := False;
    WebCheckBox2.WidthPercent := 100.000000000000000000;
    WebCheckBox1.SetParentComponent(Self);
    WebCheckBox1.Name := 'WebCheckBox1';
    WebCheckBox1.Left := 300;
    WebCheckBox1.Top := 79;
    WebCheckBox1.Width := 113;
    WebCheckBox1.Height := 22;
    WebCheckBox1.ChildOrder := 21;
    WebCheckBox1.Color := clNone;
    WebCheckBox1.HeightPercent := 100.000000000000000000;
    WebCheckBox1.State := cbUnchecked;
    WebCheckBox1.Visible := False;
    WebCheckBox1.WidthPercent := 100.000000000000000000;
    WebComboBox1.SetParentComponent(Self);
    WebComboBox1.Name := 'WebComboBox1';
    WebComboBox1.Left := 316;
    WebComboBox1.Top := 79;
    WebComboBox1.Width := 372;
    WebComboBox1.Height := 21;
    WebComboBox1.Color := clWhite;
    WebComboBox1.HeightPercent := 100.000000000000000000;
    WebComboBox1.Text := 'Ogrzewanie elektryczne';
    WebComboBox1.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox1, Self, 'OnClick', 'WebComboBox1Click');
    WebComboBox1.ItemIndex := 0;
    WebComboBox1.Items.BeginUpdate;
    try
      WebComboBox1.Items.Clear;
      WebComboBox1.Items.Add('Ogrzewanie elektryczne');
      WebComboBox1.Items.Add('Ogrzewanie w'#281'glowe');
      WebComboBox1.Items.Add('Ogrzewanie naftowe');
      WebComboBox1.Items.Add('Ogrzewanie na gaz ziemny');
      WebComboBox1.Items.Add('Gaz z energi'#261' s'#322'oneczn'#261' ciepln'#261);
      WebComboBox1.Items.Add('Sie'#263' ciep'#322'ownicza');
      WebComboBox1.Items.Add('Pompa ciep'#322'a');
      WebComboBox1.Items.Add('Drewno (pellet, drewno suszone)');
      WebComboBox1.Items.Add('Drewno z energi'#261' s'#322'oneczn'#261' ciepln'#261);
      WebComboBox1.Items.Add('Nie wiem');
    finally
      WebComboBox1.Items.EndUpdate;
    end;
    WebComboBox2.SetParentComponent(Self);
    WebComboBox2.Name := 'WebComboBox2';
    WebComboBox2.Left := 316;
    WebComboBox2.Top := 103;
    WebComboBox2.Width := 372;
    WebComboBox2.Height := 21;
    WebComboBox2.HeightPercent := 100.000000000000000000;
    WebComboBox2.Text := 'Budowa do 1994 r. (nie remontowany)';
    WebComboBox2.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox2, Self, 'OnClick', 'WebComboBox2Click');
    WebComboBox2.ItemIndex := 0;
    WebComboBox2.Items.BeginUpdate;
    try
      WebComboBox2.Items.Clear;
      WebComboBox2.Items.Add('Budowa do 1994 r. (nie remontowany)');
      WebComboBox2.Items.Add('Budowa w latach 1995 do 2001 (nieodnowiony)');
      WebComboBox2.Items.Add('Budowa od 2001 r.');
      WebComboBox2.Items.Add('W pe'#322'ni wyremontowany energetycznie (rok budowy do 1948)');
      WebComboBox2.Items.Add('W pe'#322'ni odnowiony energetycznie (rok budowy 1949 do 2001)');
      WebComboBox2.Items.Add('Dom niskoenergetyczny');
      WebComboBox2.Items.Add('Dom pasywny');
      WebComboBox2.Items.Add('Nie wiem');
    finally
      WebComboBox2.Items.EndUpdate;
    end;
    WebComboBox3.SetParentComponent(Self);
    WebComboBox3.Name := 'WebComboBox3';
    WebComboBox3.Left := 316;
    WebComboBox3.Top := 126;
    WebComboBox3.Width := 372;
    WebComboBox3.Height := 21;
    WebComboBox3.HeightPercent := 100.000000000000000000;
    WebComboBox3.Text := 'Ponad 300 m2';
    WebComboBox3.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox3, Self, 'OnClick', 'WebComboBox3Click');
    WebComboBox3.ItemIndex := 0;
    WebComboBox3.Items.BeginUpdate;
    try
      WebComboBox3.Items.Clear;
      WebComboBox3.Items.Add('Ponad 300 m2');
      WebComboBox3.Items.Add('201 - 300 m2');
      WebComboBox3.Items.Add('151 - 200 m2');
      WebComboBox3.Items.Add('126 - 150 m2');
      WebComboBox3.Items.Add('101 - 125 m2');
      WebComboBox3.Items.Add('76-100 m2');
      WebComboBox3.Items.Add('51 - 75 m2');
      WebComboBox3.Items.Add('30 - 50 m2');
      WebComboBox3.Items.Add('Mniej ni'#380' 30 m2');
    finally
      WebComboBox3.Items.EndUpdate;
    end;
    WebComboBox4.SetParentComponent(Self);
    WebComboBox4.Name := 'WebComboBox4';
    WebComboBox4.Left := 316;
    WebComboBox4.Top := 149;
    WebComboBox4.Width := 372;
    WebComboBox4.Height := 21;
    WebComboBox4.HeightPercent := 100.000000000000000000;
    WebComboBox4.Text := '1 osoba';
    WebComboBox4.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox4, Self, 'OnClick', 'WebComboBox4Click');
    WebComboBox4.ItemIndex := 0;
    WebComboBox4.Items.BeginUpdate;
    try
      WebComboBox4.Items.Clear;
      WebComboBox4.Items.Add('1 osoba');
      WebComboBox4.Items.Add('2 osoby');
      WebComboBox4.Items.Add('3 osoby');
      WebComboBox4.Items.Add('4 osoby');
      WebComboBox4.Items.Add('5 ludzi');
      WebComboBox4.Items.Add('6 os'#243'b');
      WebComboBox4.Items.Add('7 os'#243'b lub wi'#281'cej');
    finally
      WebComboBox4.Items.EndUpdate;
    end;
    WebComboBox5.SetParentComponent(Self);
    WebComboBox5.Name := 'WebComboBox5';
    WebComboBox5.Left := 316;
    WebComboBox5.Top := 172;
    WebComboBox5.Width := 372;
    WebComboBox5.Height := 21;
    WebComboBox5.HeightPercent := 100.000000000000000000;
    WebComboBox5.Text := 'Ponad 23'#176'C';
    WebComboBox5.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox5, Self, 'OnClick', 'WebComboBox5Click');
    WebComboBox5.ItemIndex := 0;
    WebComboBox5.Items.BeginUpdate;
    try
      WebComboBox5.Items.Clear;
      WebComboBox5.Items.Add('Ponad 23'#176'C');
      WebComboBox5.Items.Add('Oko'#322'o 21'#176'C');
      WebComboBox5.Items.Add('Maksymalnie 19'#176'C');
      WebComboBox5.Items.Add('Maksymalnie 17'#176'C');
      WebComboBox5.Items.Add('Nie wiem');
    finally
      WebComboBox5.Items.EndUpdate;
    end;
    WebComboBox6.SetParentComponent(Self);
    WebComboBox6.Name := 'WebComboBox6';
    WebComboBox6.Left := 316;
    WebComboBox6.Top := 195;
    WebComboBox6.Width := 372;
    WebComboBox6.Height := 21;
    WebComboBox6.HeightPercent := 100.000000000000000000;
    WebComboBox6.Text := 'Kocio'#322' elektryczny';
    WebComboBox6.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox6, Self, 'OnClick', 'WebComboBox6Click');
    WebComboBox6.ItemIndex := 0;
    WebComboBox6.Items.BeginUpdate;
    try
      WebComboBox6.Items.Clear;
      WebComboBox6.Items.Add('Kocio'#322' elektryczny');
      WebComboBox6.Items.Add('Ogrzewanie w'#281'glowe');
      WebComboBox6.Items.Add('Ogrzewanie naftowe');
      WebComboBox6.Items.Add('Ogrzewanie na gaz ziemny');
      WebComboBox6.Items.Add('Pompa ciep'#322'a');
      WebComboBox6.Items.Add('Sie'#263' ciep'#322'ownicza');
      WebComboBox6.Items.Add('Gaz z kolektorami s'#322'onecznymi');
      WebComboBox6.Items.Add('Drewno (pellet, drewno suszone)');
      WebComboBox6.Items.Add('Drewno z termiczn'#261' energi'#261' s'#322'oneczn'#261);
      WebComboBox6.Items.Add('Nie wiem');
    finally
      WebComboBox6.Items.EndUpdate;
    end;
    WebComboBox7.SetParentComponent(Self);
    WebComboBox7.Name := 'WebComboBox7';
    WebComboBox7.Left := 316;
    WebComboBox7.Top := 218;
    WebComboBox7.Width := 372;
    WebComboBox7.Height := 21;
    WebComboBox7.HeightPercent := 100.000000000000000000;
    WebComboBox7.Text := 'Klasa A oraz lepiej';
    WebComboBox7.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox7, Self, 'OnClick', 'WebComboBox7Click');
    WebComboBox7.ItemIndex := 1;
    WebComboBox7.Items.BeginUpdate;
    try
      WebComboBox7.Items.Clear;
      WebComboBox7.Items.Add('Gorzej ni'#380' klasa A');
      WebComboBox7.Items.Add('Klasa A oraz lepiej');
      WebComboBox7.Items.Add('Klasa A + orazi lepiej');
      WebComboBox7.Items.Add('Klasa A ++  oraz  lepiej');
      WebComboBox7.Items.Add('Nie wiem - wi'#281'kszo'#347#263' moich sprz'#281't'#243'w AGD ma wi'#281'cej ni'#380' 10 lat');
      WebComboBox7.Items.Add('Nie wiem - wi'#281'kszo'#347#263' moich sprz'#281't'#243'w AGD ma mniej ni'#380' 10 lat');
    finally
      WebComboBox7.Items.EndUpdate;
    end;
    WebComboBox8.SetParentComponent(Self);
    WebComboBox8.Name := 'WebComboBox8';
    WebComboBox8.Left := 316;
    WebComboBox8.Top := 241;
    WebComboBox8.Width := 372;
    WebComboBox8.Height := 21;
    WebComboBox8.HeightPercent := 100.000000000000000000;
    WebComboBox8.Text := 'Lod'#243'wka z ma'#322'ym zamra'#380'alnikiem';
    WebComboBox8.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox8, Self, 'OnClick', 'WebComboBox8Click');
    WebComboBox8.ItemIndex := 2;
    WebComboBox8.Items.BeginUpdate;
    try
      WebComboBox8.Items.Clear;
      WebComboBox8.Items.Add('Kilka lod'#243'wek i/lub zamra'#380'arek');
      WebComboBox8.Items.Add('Kombinacja lod'#243'wko-zamra'#380'arki (dwudrzwiowa) lub lod'#243'wka z ma'#322'ym zamra'#380'alnikiem w po'#322#261'czeniu z zamra'#380'ark'#261);
      WebComboBox8.Items.Add('Lod'#243'wka z ma'#322'ym zamra'#380'alnikiem');
    finally
      WebComboBox8.Items.EndUpdate;
    end;
    WebComboBox9.SetParentComponent(Self);
    WebComboBox9.Name := 'WebComboBox9';
    WebComboBox9.Left := 316;
    WebComboBox9.Top := 264;
    WebComboBox9.Width := 372;
    WebComboBox9.Height := 21;
    WebComboBox9.HeightPercent := 100.000000000000000000;
    WebComboBox9.Text := 'Na sznurku';
    WebComboBox9.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox9, Self, 'OnClick', 'WebComboBox9Click');
    WebComboBox9.ItemIndex := 2;
    WebComboBox9.Items.BeginUpdate;
    try
      WebComboBox9.Items.Clear;
      WebComboBox9.Items.Add('Tylko w suszarce b'#281'bnowej lub pomieszczeniu z suszark'#261' powietrzn');
      WebComboBox9.Items.Add(#261);
      WebComboBox9.Items.Add('Cz'#281#347'ciowo z suszark'#261' b'#281'bnow'#261' / suszark'#261' powietrzn'#261', cz'#281#347'ciowo na sznurku');
      WebComboBox9.Items.Add('Na sznurku');
    finally
      WebComboBox9.Items.EndUpdate;
    end;
    WebEdit6.SetParentComponent(Self);
    WebEdit6.Name := 'WebEdit6';
    WebEdit6.Left := 256;
    WebEdit6.Top := 79;
    WebEdit6.Width := 38;
    WebEdit6.Height := 22;
    WebEdit6.ChildOrder := 30;
    WebEdit6.HeightPercent := 100.000000000000000000;
    WebEdit6.Text := '0';
    WebEdit6.Visible := False;
    WebEdit6.WidthPercent := 100.000000000000000000;
    WebEdit7.SetParentComponent(Self);
    WebEdit7.Name := 'WebEdit7';
    WebEdit7.Left := 256;
    WebEdit7.Top := 102;
    WebEdit7.Width := 38;
    WebEdit7.Height := 22;
    WebEdit7.ChildOrder := 30;
    WebEdit7.HeightPercent := 100.000000000000000000;
    WebEdit7.Text := '0';
    WebEdit7.Visible := False;
    WebEdit7.WidthPercent := 100.000000000000000000;
    WebEdit12.SetParentComponent(Self);
    WebEdit12.Name := 'WebEdit12';
    WebEdit12.Left := 257;
    WebEdit12.Top := 125;
    WebEdit12.Width := 38;
    WebEdit12.Height := 22;
    WebEdit12.ChildOrder := 30;
    WebEdit12.HeightPercent := 100.000000000000000000;
    WebEdit12.Text := '0';
    WebEdit12.Visible := False;
    WebEdit12.WidthPercent := 100.000000000000000000;
    WebEdit13.SetParentComponent(Self);
    WebEdit13.Name := 'WebEdit13';
    WebEdit13.Left := 256;
    WebEdit13.Top := 148;
    WebEdit13.Width := 38;
    WebEdit13.Height := 22;
    WebEdit13.ChildOrder := 30;
    WebEdit13.HeightPercent := 100.000000000000000000;
    WebEdit13.Text := '0';
    WebEdit13.Visible := False;
    WebEdit13.WidthPercent := 100.000000000000000000;
    WebEdit14.SetParentComponent(Self);
    WebEdit14.Name := 'WebEdit14';
    WebEdit14.Left := 257;
    WebEdit14.Top := 171;
    WebEdit14.Width := 38;
    WebEdit14.Height := 22;
    WebEdit14.ChildOrder := 30;
    WebEdit14.HeightPercent := 100.000000000000000000;
    WebEdit14.Text := '0';
    WebEdit14.Visible := False;
    WebEdit14.WidthPercent := 100.000000000000000000;
    WebEdit15.SetParentComponent(Self);
    WebEdit15.Name := 'WebEdit15';
    WebEdit15.Left := 257;
    WebEdit15.Top := 195;
    WebEdit15.Width := 38;
    WebEdit15.Height := 22;
    WebEdit15.ChildOrder := 30;
    WebEdit15.HeightPercent := 100.000000000000000000;
    WebEdit15.Text := '0';
    WebEdit15.Visible := False;
    WebEdit15.WidthPercent := 100.000000000000000000;
    WebEdit18.SetParentComponent(Self);
    WebEdit18.Name := 'WebEdit18';
    WebEdit18.Left := 256;
    WebEdit18.Top := 219;
    WebEdit18.Width := 38;
    WebEdit18.Height := 22;
    WebEdit18.ChildOrder := 30;
    WebEdit18.HeightPercent := 100.000000000000000000;
    WebEdit18.Text := '0';
    WebEdit18.Visible := False;
    WebEdit18.WidthPercent := 100.000000000000000000;
    WebEdit19.SetParentComponent(Self);
    WebEdit19.Name := 'WebEdit19';
    WebEdit19.Left := 257;
    WebEdit19.Top := 242;
    WebEdit19.Width := 38;
    WebEdit19.Height := 22;
    WebEdit19.ChildOrder := 30;
    WebEdit19.HeightPercent := 100.000000000000000000;
    WebEdit19.Text := '0';
    WebEdit19.Visible := False;
    WebEdit19.WidthPercent := 100.000000000000000000;
    WebEdit20.SetParentComponent(Self);
    WebEdit20.Name := 'WebEdit20';
    WebEdit20.Left := 257;
    WebEdit20.Top := 265;
    WebEdit20.Width := 38;
    WebEdit20.Height := 22;
    WebEdit20.ChildOrder := 30;
    WebEdit20.HeightPercent := 100.000000000000000000;
    WebEdit20.Text := '0';
    WebEdit20.Visible := False;
    WebEdit20.WidthPercent := 100.000000000000000000;
  finally
    WebLabel7.AfterLoadDFMValues;
    WebLabel26.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebLabel22.AfterLoadDFMValues;
    WebLabel23.AfterLoadDFMValues;
    WebLabel24.AfterLoadDFMValues;
    WebLabel25.AfterLoadDFMValues;
    WebLabel28.AfterLoadDFMValues;
    Dom.AfterLoadDFMValues;
    Opis.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebCheckBox9.AfterLoadDFMValues;
    WebCheckBox8.AfterLoadDFMValues;
    WebCheckBox7.AfterLoadDFMValues;
    WebCheckBox6.AfterLoadDFMValues;
    WebCheckBox5.AfterLoadDFMValues;
    WebCheckBox4.AfterLoadDFMValues;
    WebCheckBox3.AfterLoadDFMValues;
    WebCheckBox2.AfterLoadDFMValues;
    WebCheckBox1.AfterLoadDFMValues;
    WebComboBox1.AfterLoadDFMValues;
    WebComboBox2.AfterLoadDFMValues;
    WebComboBox3.AfterLoadDFMValues;
    WebComboBox4.AfterLoadDFMValues;
    WebComboBox5.AfterLoadDFMValues;
    WebComboBox6.AfterLoadDFMValues;
    WebComboBox7.AfterLoadDFMValues;
    WebComboBox8.AfterLoadDFMValues;
    WebComboBox9.AfterLoadDFMValues;
    WebEdit6.AfterLoadDFMValues;
    WebEdit7.AfterLoadDFMValues;
    WebEdit12.AfterLoadDFMValues;
    WebEdit13.AfterLoadDFMValues;
    WebEdit14.AfterLoadDFMValues;
    WebEdit15.AfterLoadDFMValues;
    WebEdit18.AfterLoadDFMValues;
    WebEdit19.AfterLoadDFMValues;
    WebEdit20.AfterLoadDFMValues;
  end;
end;

end.
